<template>
  <div class="mainContent grid">
    <div class="page-block u-16">
      <div class="title-page">
        <h1 style="margin-bottom:20px">Отчетность</h1>
      </div>
      <VisualSearch
        v-if="flag_cp"
        v-on:sendRequest="sendRequest"
        :merchantList="merchantList"
        :terminalList="terminalList"
        :processingList="processingList"
        :statusList="statusList"
        :isReport="isReport"
        :isSplits="isSplits"
        :isClick="isClick"
      />

      <div class="report-options grid cross-center">
        <div class="hint u-16">
          Введите в поле email один или несколько адресов через запятую
        </div>
        <el-input
          placeholder="Email"
          v-model="email"
          size="large"
          clearable
          class="r-margin-10"
        ></el-input>

        <el-select
            size="large"
            v-model="timezone"
            placeholder="Выберите таймзону"
            filterable
            class= "r-margin-10"
        >
          <el-option
              v-for="(item) in timezonesList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
          ></el-option>
        </el-select>

        <el-button
          v-if="isReport"
          type="primary"
          size="large"
          :loading="loading"
          class="download"
          @click="downloadReport(reportRequest)"
        >
          <i v-show="!loading" class="el-icon-download"></i> Скачать отчет
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { mapGetters } from "vuex";
import { _ } from "underscore";
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";
import timezones from "@/localize/timezonesList.js";

import VisualSearch from "@/components/VisualSearch";
export default {
  name: "Reports",
  data() {
    return {
      loading: false,
      reportRequest: {},
      isClick: false,
      isReport: true,
      isSplits: false,
      flag_cp: false,
      url: "",
      header: {
        "Content-Type": "text/csv"
      },
      defaultParam: {
        id: -1,
        limit: -1,
        offset: 0,
        order_by: "id",
        order: "desc",
        download: true
      },
      optionsType: [
        {
          value: "csv",
          label: "CSV"
        }
      ],
      email: "",
      timezonesList: { ...timezones },
      timezone: 0
    };
  },
  methods: {
    sendRequest(request) {
      this.reportRequest = request;
    },
    downloadReport(request) {
      if (!this.validateEmail(this.email)) return false;
      let paramRequest;
      let emails = this.email
        .replace(/\s/, "")
        .toLowerCase()
        .split(",");
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      request.timezone = this.timezone;
      if (!_.isEmpty(request)) {
        paramRequest = Object.assign({}, this.defaultParam, request);
      } else {
        paramRequest = this.defaultParam;
      }
      this.loading = true;
      axios
        .post(apiUrl + "transaction", { ...paramRequest, emails }, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Отчеты генерируются и скоро придут на Вашу почту",
              type: "success",
              duration: 3000
            });
          } else {
            this.$message({
              message: data.message,
              type: "error",
              duration: 3000
            });
          }
          this.loading = false;
        })
        .catch(error => {
          this.$message.error("Не удалось обработать запрос");
          this.loading = false;
          throw error;
        });
    },
    validateEmail(email) {
      if (email && email != "") {
        let reg = /^[a-zа-яA-ZА-Я0-9._%+\-]+@[a-zа-яA-ZА-Я0-9.\-]+\.[a-zа-яA-ZА-Я]{2,12}$/;
        email = email.replace(/\s/, "");
        let emails = email.split(",");
        let count = 0;
        emails.forEach(element => {
          if (reg.test(element)) count++;
          else {
            this.$message({
              message: "Введите корретный email",
              type: "error",
              duration: 3000
            });
            return false;
          }
        });
        return count > 0;
      } else {
        this.$message({
          message: "Введите email",
          type: "error",
          duration: 3000
        });
        return false;
      }
    },
  },
  created() {
    this.$store.dispatch("getTerminal").then(() => {
      this.$store.dispatch("getCustomParams");
      this.customP = this.customParams;
      this.flag_cp = true;
    });
    this.$store.dispatch("getProcessing");
    this.$store.dispatch("getRules");
    this.$store.dispatch("getMerchant");
    if (this.getProfile) {
      this.email = this.getProfile.email ? this.getProfile.email : "";
    }

    let time = new Date();
    this.timezone = time.getTimezoneOffset();
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "getRights",
      "merchantList",
      "merchantName",
      "terminalList",
      "terminalName",
      "processingList",
      "processingName",
      "processingIcon",
      "statusList",
      "decisionList",
      "decisionName",
      "decisionStyle",
      "cardClass",
      "cardName",
      "holderImg",
      "customParams",
      "decisionAF",
      "afruleName",
      "currencyCharacter",
      "countryNameRu"
    ])
  },
  beforeMount() {
    this.$store.dispatch("getMerchant");
    this.$store.dispatch("getTerminal");
    this.$store.dispatch("getProcessing");
  },
  components: {
    VisualSearch
  }
};
</script>

<style lang="sass" scoped>
.el-input
  max-width: 300px
.report-options .hint
    color: #777
    line-height: 1.5
    font-size: 13px
    text-align: left
    font-style: normal
    margin-bottom: 10px
</style>
